import { useEffect } from 'react';

const Login= () => {
    useEffect(() => {
        window.location.href = 'https://internship.aranish.uk/login';
    }, []);

    return null;
};

export default Login;
